export default "__VITE_ASSET__BWhsCZoq__"